export const siteIsActivated = (site) => {
  let siteIsActivated = true;
  if (site.state === 2) {
    siteIsActivated = false;
  }
  if (site.state === 1) {
    siteIsActivated = false;
  }
  return siteIsActivated;
}


// WEBPACK FOOTER //
// ./src/services/SiteService.js